import { ConditionType, type IConditionDto, ConditionBase, ConditionState, type IConditionLabelOptions, type IVehicle, ConfigurationType } from "..";

export class RegoCondition extends ConditionBase
{

    constructor( vehicle: IVehicle, model: IConditionDto )
    {
        super( vehicle, model, ConditionType.Rego, ConfigurationType.Date, false );
        this.icon = 'help-me:insurance';
        this.ordinal = 1;
        this.initialise();
    }

    /**
     * Gets the labels for the condition.  The labels are used to provide meaningful
     * user interface statements/prompts that are specific to the condition
     */
    override getLabels(): IConditionLabelOptions 
    {
        return {
            name: "Rego",
            shortName: 'Rego',
            longName: "Rego",
            intervalJustCompletedMessage: "Rego was just completed",
            cta: "Find a rego provider",
            maintenanceVerb: 'Rego Renewal',
            protectedByLabel: 'Your car is protected by'
        };
    }

    /**
     * Gets the description for the interval update for this condition
     * @returns 
     */
    protected override getIntervalDescription()
    {
        if( this.averageOdometerInterval == 0 ) return 'n/a';
        return `To abide by State and Territory laws, a car needs to be registered every ${ super.getIntervalDescription( this.vehicle, this ) }`;
    }

    /**
     * Gets the action message for the service note
     */
    override getActionMessage() 
    {
        switch( this.state )
        {
            case ConditionState.Due: return "Your rego is due, you should organise your car's rego as soon as possible";
            case ConditionState.Overdue: return "Your rego is overdue, you should organise your car's rego as soon as possible";
            case ConditionState.Critical: return "Your rego is overdue, you should organise your car's rego as soon as possible";
            default: return "";
        }
    }
    
}
